"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash/noop"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const useOfxShadowAccountInfoDialog = () => {
    const { dialogAlert } = (0, useQDialogs_1.default)();
    return (0, react_1.useCallback)(() => {
        dialogAlert('How this account updates', <>
        {'This Direct Connect account gets new transactions through Quicken Desktop. After you update your accounts and sync your desktop data, the transactions appear in the web app.'}
        <br />
        <br />
        {'Express Web Connect and Express Web Connect+ accounts can be updated by refreshing in the web app.'}
        <br />
        <br />
        <Link_1.default href={'https://www.quicken.com/support/updates-to-your-direct-connect-access-in-quicken-classic-mobile-and-web-companion-apps'} target="_blank" rel="noopener noreferrer" underline={'hover'}>
          {'Learn more...'}
        </Link_1.default>
      </>, noop_1.default, ['Ok'], '', false);
    }, [dialogAlert]);
};
exports.default = useOfxShadowAccountInfoDialog;
